<template>
  <s-form
      v-if="!loading && commonsLoaded"
      ref="form"
      :model="formDada"
      :title="tripTitle"
      label-width="120px"
      v-loading="pocessing"
      element-loading-text="pocessing..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)">
    <!-- :extraQueryParams="{limit:20,tripTypes:'ARV',plandate:arvFlightDate}" -->
    <!--    <h2 >{{ tripKind }}</h2 >-->
    <s-form-item
        label="Title"
        v-if="tripKind == 'EXCRS' || tripKind == 'PACKAGE'"
        :sz="12">
      <s-remote-select
          v-model="formDada.serviseId"
          label-prop="title"
          value-prop="id"
          prefixField="startTimeF"
          class-model="tripservice"
          :extraQueryParams="{ limit: 20, kind: tripKind }"
          @change-option-data="handleTripChange"></s-remote-select>
    </s-form-item>
    <s-form-item
        label="Flight Number"
        v-if="tripKind == 'FLIGHT'||tripKind == 'DEP'||tripKind == 'ARV'"
        :sz="8">
      <el-input v-model="formDada.flight"></el-input>

    </s-form-item>
    <s-form-item
        label="Direction"
        v-if="tripKind == 'FLIGHT'||tripKind == 'DEP'||tripKind == 'ARV'"
        :sz="6">

      <el-radio-group v-model="formDada.tripType">
        <el-radio-button label="ARV"></el-radio-button>
        <el-radio-button label="DEP"></el-radio-button>
      </el-radio-group>
    </s-form-item>
    <s-form-item
        label="Start Date/Time"
        :sz="10">
      <!-- <p>{{formDada.time}}!</p> -->
      <!--      <s-dater-->
      <!--        v-if="ScheduleTrip"-->
      <!--        xstyle="float:right"-->
      <!--        type="datetime"-->
      <!--        v-model="ScheduleTrip.time"-->
      <!--        xchange="updateCommon('ScheduleTrip')"-->
      <!--      ></s-dater>-->
      <s-dater
          xtype="minimal===false?'datetime':'date'"
          type="datetime"
          v-model="formDada.time"
          xdisplayFormat="minimal===false?null:'dd/MM/yyyy'"></s-dater>
      <!--      <p>-=-=-={{ formDada.time }}</p>-->
    </s-form-item>
    <s-form-item
        label="Capacty"
        v-if="tripKind == 'EXCRS'"
        :sz="12">
      <el-input v-model="formDada.capacity"></el-input>
    </s-form-item>
    <s-form-actions>
      <el-popover

          slot="left"
          v-if="formDada.id&&minimal===false"
          placement="bottom-start"
          title="Delete this trip?"
          width="200"
          trigger="hover"
          content="this is content, this is content, this is content">
        <sf-button
            type="danger"
            slot="reference">Delete
        </sf-button>
        <template>
          <el-checkbox
              v-model="formDada.delete_bookings"
              style="color: #ff0000">!!!delete also bookings
          </el-checkbox>
          <s-btn-delete
              type="danger"
              style="float: left"
              @go="deleteData()"></s-btn-delete>
        </template>
      </el-popover>
      <sf-button
          slot="middle"
          v-if="tripKind != 'PACKAGE'&&minimal===false"
          type="warning"
          @click="toggleStatus()"
          :material="
          formDada.execstatus == 'normal'
            ? 'do_not_disturb_alt'
            : 'check_circle'
        "></sf-button>

      <sf-button
          slot="middle"
          type="warning"
          @click="toggleLock()"
          v-if="tripKind != 'PACKAGE'&&minimal===false">
        <span class="material-icons">{{
            formDada.lockState == "normal" ? "lock" : "lock_open"
          }}</span>
      </sf-button>
      <!--      <sf-button-->
      <!--        type="success"-->
      <!--        @click="updateCommon('ScheduleTrip')"-->
      <!--        v-if="ScheduleTrip"-->
      <!--        >Update</sf-button-->
      <!--      >-->
      <template v-if="minimal===false">
        <sf-button
            type="primary"
            @click="saveData()"
            cv-else>{{ formDada && formDada.id ? 'Update' : 'Create' }}
        </sf-button>
      </template>
      <template v-else>
        <sf-button
            type="primary"
            material="done"
            @click="saveData()"
        >
        </sf-button>
      </template>
      <!-- <sf-button @click="$emit('cancel')">Cancel</sf-button> -->
    </s-form-actions>
  </s-form>
</template>

<script>
import * as api from "~/api/resource";
import commons from "~/mixins/commons";

export default {
  mixins: [commons],

  name: "schedule-trip-form",
  props: {
    minimal: {type: Boolean, default: false},
    tripid: {default: null},
    value: {
      type: Object, default: () => {
      }
    },
  },
  async mounted() {
    var vm = this;
    if (this.value) {
      if (this.value.id) await this.loadData(this.value.id);
      else {
        // if (_.isNumber(this.value.time)) this.formatUnxTime(this.value.time, true);

        this.formDada = this.value;
      }
    } else await this.loadData();
    _log_("ooo ", this.$route);
    this.loading = false;
  },
  data() {
    return {
      loading: true,
      errors: {},
      pocessing: false,
      formDada: {},
      createdForNewService: null
    };
  },
  methods: {

    handleTripChange(ev) {
      _log_("handleTripChange", ev);
      // return
      this.createdForNewService = ev
      let cT = new Date(this.formDada.time * 1000)
      const tmSplit = ev.startTimeF.split(':')
      cT.setHours(tmSplit[0], tmSplit[1])
      this.formDada.time = cT.getTime() / 1000
    },
    async toggleLock() {
      this.formDada.lockState =
          this.formDada.lockState != "normal" ? "normal" : "lock";
      // _log_(
      //   "go set this.ScheduleTrip.lockState ",
      //   this.formDada.lockState
      // );
      await this.saveData();
    },
    async toggleStatus() {
      this.formDada.execstatus =
          this.formDada.execstatus != "normal" ? "normal" : "cancel";
      // _log_(
      //   "go set this.ScheduleTrip.lockState ",
      //   this.formDada.lockState
      // );
      await this.saveData();
    },
    async deleteData() {
      this.pocessing = true;

      try {
        this.formDada = await api.removeObject("scheduletrip", this.formDada);
      } catch (error) {
        this.$message.error("Oops, " + error.message);
        this.pocessing = false;
        return;
      }

      this.$emit("delete", this.formDada);
      this.$emit("done", null);
      this.pocessing = false;
    },
    async saveData() {
      this.pocessing = true;


      if (this.minimal) {
        let timeSet = new Date(this.formDada.time * 1000)
        timeSet.setHours(this.formDada._originalTime.getHours())
        timeSet.setMinutes(this.formDada._originalTime.getMinutes())
        this.formDada.time = Math.floor(timeSet.getTime() / 1000);
      }
      let timeCheck = new Date(this.formDada.time * 1000)
      _log_('helo', this.formDada.time)
      if (this.ScheduleTrip) {
        const tripService = this.createdForNewService ? this.createdForNewService : this.ScheduleTrip.TripService;
        if (tripService) if (Math.abs(timeCheck.getHours() - tripService.startTime / 60) > 4)//something is wrong with the time
        {
          let notf = this.$notify.warning({
            title: "Be careful",
            position: 'top-right',
            message: "The default time of this trip is " + this.intToTime(tripService.startTime) + " Click here to reset time if you wish",
            duration: 5000,
            onClick: () => {
              timeCheck.setHours(tripService.startTime / 60)
              timeCheck.setMinutes(tripService.startTime % 60)
              this.formDada.time = timeCheck.getTime() / 1000
              notf.close();
              notf = null;
            },
          });
          // _log_("SAV E", Math.abs(timeCheck.getHours() - tripService.startTime / 60), this.formDada);
          // timeCheck.setHours(tripService.startTime / 60)
          // timeCheck.setMinutes(tripService.startTime % 60)
          // this.formDada.time = timeCheck.getTime() / 1000
        }
      }
      try {

        this.formDada = await api.updateProcessor(
            "scheduletrip/update",
            this.minimal ? {...this.formDada, _findOrCreateCtx: 'bookings'} : this.formDada
        );
      } catch (error) {
        _log_(error);
        alert(error.message);
      }

      _log_("get b oo ", this.formDada);
      this.$emit("update", this.formDada);
      this.$emit("change", this.formDada);
      this.$emit("done", this.formDada);
      this.routeGo({params: {tripid: this.formDada.id}}, true);
      this.pocessing = false;
    },
    async loadData(id) {

      this.loading = true;
      id = id ? id : this.$route.params.tripid;
      if (id) {
        if (id == "new")
          this.formDada = await api.fetchObject("scheduletrip", {
            tripType: this.tripKind == "FLIGHT" ? 'ARV' : this.tripKind,
          });
        else
          this.formDada = await api.fetchObject("scheduletrip", {
            id: id,
          });
      }
      this.formDada._originalTime = new Date(this.formDada.time * 1000)
      this.loading = false;
    },
  },
  computed: {
    tripTitle() {
      var what = "";
      if (this.tripKind == "PACKAGE") what = "Package Group";
      if (this.tripKind == "EXCRS") what = "Activity";
      if (
          this.tripKind == "ARV" ||
          this.tripKind == "DEP" ||
          this.tripKind == "FLIGHT"
      )
        what = "Flight";
      return (
          "<small>Setup " +
          what +
          " </small> " +
          (this.formDada.tripName ? this.formDada.tripName : "NEW")
      );
    },
    tripKind() {
      if (this.formDada && this.formDada.tripType)
        return this.formDada.tripType;
      const sniff = this.$route.params.kind
          ? this.$route.params.kind.toUpperCase()
          : null;
      if (sniff.indexOf('ARV') >= 0 && sniff.indexOf('DEP') >= 0)
        return 'FLIGHT'
      return sniff
    },
  },
  watch: {
    value: async function (val, oldval) {
      if (val) {
        // if (_.isNumber(val.time)) this.formatUnxTime(val.time, true);
        if (!val.id) this.formDada = val;
      }
    },
    "value.id": async function (tripid, oldval) {
      _log_("get b oo ", tripid, oldval);
      // if (!tripid) this.formDada = value;
      if (tripid != oldval) {
        await this.loadData(tripid);
        // this.loading = true;
        // var { data } = await api.fetchProcessor(
        //   "bookings/vuebooking",
        //   this.$route.query
        // );
        // this.booking = data.results;
        // this.loading = false;
      }
    },
    "$route.params.tripid": async function (tripid, oldval) {
      _log_("get b oo ", tripid, oldval);
      if (tripid != oldval) {
        await this.loadData(tripid);
        // this.loading = true;
        // var { data } = await api.fetchProcessor(
        //   "bookings/vuebooking",
        //   this.$route.query
        // );
        // this.booking = data.results;
        // this.loading = false;
      }
    },
  },
};
</script>
